import React from 'react';

type DownloadActionIconProps = {
  className?: string;
};

export default function DownloadActionIcon({ className }: DownloadActionIconProps) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      width="17"
      height="15"
      viewBox="0 0 11 14"
      fill="none"
    >
      <path
        d="M1.83333 0C0.822135 0 0 0.784766 0 1.75V12.25C0 13.2152 0.822135 14 1.83333 14H9.16667C10.1779 14 11 13.2152 11 12.25V4.375H7.33333C6.8263 4.375 6.41667 3.98398 6.41667 3.5V0H1.83333ZM7.33333 0V3.5H11L7.33333 0ZM2.52083 6.125H8.47917C8.9862 6.125 9.39583 6.51602 9.39583 7V7.4375V9.625V11.375C9.39583 11.859 8.9862 12.25 8.47917 12.25H6.64583H4.35417H2.52083C2.0138 12.25 1.60417 11.859 1.60417 11.375V9.625V7.4375V7C1.60417 6.51602 2.0138 6.125 2.52083 6.125ZM2.52083 9.1875H3.89583V7.875H2.52083V9.1875ZM4.8125 9.1875H6.1875V7.875H4.8125V9.1875ZM7.10417 9.1875H8.47917V7.875H7.10417V9.1875ZM7.10417 10.0625V11.375H8.47917V10.0625H7.10417ZM6.1875 10.0625H4.8125V11.375H6.1875V10.0625ZM3.89583 10.0625H2.52083V11.375H3.89583V10.0625Z"
        fill="#424242"/>
    </svg>
  );
}
